<template>
  <div>
    <v-app-bar app flat dark color="primary">
      <v-app-bar-nav-icon
        @click.native.stop="updateUILeftDrawerState(!UILeftDrawer)"
        v-if="!screenIsWideEnough"
      ></v-app-bar-nav-icon>
      <v-layout align-center>
        <v-text-field
          name="search"
          v-model="search"
          clearable
          flat
          placeholder="Search Accounts"
          solo-inverted
          hide-details
          prepend-inner-icon="search"
          style="min-width:280px;max-width:280px;width:280px"
        ></v-text-field>
        <v-toolbar-items>
          <v-btn-toggle multiple v-model="toggles" class="ml-4 transparent">
            <v-btn text @click="toggleBusinessTypeFilter('bank')"
              ><v-icon class="mr-1">fad fa-university</v-icon> Banks</v-btn
            >
            <v-btn text @click="toggleBusinessTypeFilter('customer')">
              <v-icon class="mr-1">fad fa-users</v-icon> Customers
            </v-btn>
            <v-btn text @click="toggleBusinessTypeFilter('partner')">
              <v-icon class="mr-1">fad fa-handshake</v-icon> Partners
            </v-btn>
            <v-btn text @click="toggleBusinessTypeFilter('provider')">
              <v-icon class="mr-1">fad fa-coins</v-icon> Funders
            </v-btn>
            <v-btn text @click="toggleBusinessTypeFilter('introducer')">
              <v-icon class="mr-1">fad fas fa-user-tie</v-icon> Introducers
            </v-btn>
          </v-btn-toggle>
        </v-toolbar-items>
        <v-toolbar-items>
          <v-btn text @click="clearSearch"><v-icon class="mr-1">clear</v-icon> Clear</v-btn>
        </v-toolbar-items>
      </v-layout>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-content>
      <v-container fill-height fluid class="pa-0 calc-height grey lighten-2">
        <v-layout :class="{ 'ml-0': $vuetify.breakpoint.width <= 1600, 'ml-4': $vuetify.breakpoint.width > 1600 }">
          <v-flex class="list-bar" :class="{ hidden: !screenIsWideEnough }" ref="scrollContainer">
            <v-list class="pt-0" two-line dense v-if="AccountsList.length > 0">
              <template v-for="account in AccountsList">
                <v-list-item
                  :key="`list-${account.id}`"
                  @click="selectAccount(account.id)"
                  :class="{ selected: account.id === SelectedAccount.id }"
                >
                  <v-list-item-content>
                    <v-list-item-title style="max-width:250px;overflow: hidden;text-overflow: ellipsis">
                      {{ account.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle>{{ account.bbb_id }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider :key="`divider-${account.id}`"></v-divider>
              </template>
              <mugen-scroll
                :handler="scrollPage"
                scroll-container="scrollContainer"
                :threshold="0.1"
                :should-handle="!loading"
                v-if="pagesAvailable"
              >
                <v-layout align-center justify-center>
                  <v-progress-circular
                    size="25"
                    :width="3"
                    color="accent"
                    indeterminate
                    class="py-4"
                  ></v-progress-circular>
                </v-layout>
              </mugen-scroll>
            </v-list>
            <v-list two-line dense v-else>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title style="max-width:250px;overflow: hidden;text-overflow: ellipsis"
                    >No accounts found</v-list-item-title
                  >
                  <v-list-item-subtitle>we couldn't find the account</v-list-item-subtitle>
                  <v-list-item-subtitle>you are looking for</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-flex>

          <v-flex v-if="AccountsList.length > 0" style="overflow-y:auto;min-width:905px;">
            <v-card
              flat
              class="transparent"
              :class="{ 'ml-0': $vuetify.breakpoint.width <= 1600, 'ml-4': $vuetify.breakpoint.width > 1600 }"
            >
              <v-tabs background-color="grey lighten-3" v-model="tabs">
                <v-tabs-slider color="accent"></v-tabs-slider>
                <v-tab key="details">Details</v-tab>
                <v-tab key="businesses">Businesses</v-tab>
                <v-tab key="users">Users</v-tab>
              </v-tabs>
            </v-card>
            <v-tabs-items
              v-model="tabs"
              class="grey lighten-2"
              :class="{ 'ml-0': $vuetify.breakpoint.width <= 1600, 'ml-4': $vuetify.breakpoint.width > 1600 }"
            >
              <v-tab-item key="details">
                <v-container
                  class="pt-2"
                  :class="{ 'px-2': $vuetify.breakpoint.width <= 1600, 'pl-0': $vuetify.breakpoint.width > 1600 }"
                >
                  <v-layout>
                    <v-flex xs12 sm9 md6>
                      <v-card class="pa-2">
                        <v-card-text>
                          <v-form lazy-validation>
                            <v-container grid-list-md>
                              <v-layout wrap>
                                <v-flex xs12>
                                  <v-text-field label="Account Name" v-model="account.name"></v-text-field>
                                </v-flex>
                              </v-layout>
                              <v-layout wrap>
                                <v-flex xs12 sm6>
                                  <v-text-field label="Email" v-model="account.email"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                  <v-text-field label="Phone" v-model="account.phone"></v-text-field>
                                </v-flex>
                              </v-layout>
                              <v-layout column v-if="account.address">
                                <v-layout wrap>
                                  <v-flex xs12 sm6>
                                    <v-text-field
                                      label="Address Line 1"
                                      v-model="account.address.line_1"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm6>
                                    <v-text-field
                                      label="Address Line 2"
                                      v-model="account.address.line_2"
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                                <v-layout wrap>
                                  <v-flex xs12 sm6>
                                    <v-text-field
                                      label="Address Line 3"
                                      v-model="account.address.line_3"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm6>
                                    <v-text-field
                                      label="Address Line 4"
                                      v-model="account.address.line_4"
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                                <v-layout wrap>
                                  <v-flex xs12 sm6>
                                    <v-text-field
                                      label="Address Line 5"
                                      v-model="account.address.line_5"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm6>
                                    <v-text-field label="Post Code" v-model="account.address.post_code"></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-layout>
                            </v-container>
                          </v-form>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="accent" @click="updateDetails">Update</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-tab-item>
              <v-tab-item key="businesses">
                <account-businesses></account-businesses>
              </v-tab-item>
              <v-tab-item key="users">
                <account-users></account-users>
              </v-tab-item>
            </v-tabs-items>
          </v-flex>
        </v-layout>
      </v-container>
      <v-speed-dial v-model="fab" fixed bottom right open-on-hover transition="slide-y-transition">
        <template v-slot:activator>
          <v-btn color="accent darken-1" dark fab v-model="fab">
            <v-icon v-if="fab">close</v-icon>
            <v-icon v-else>fa-plus</v-icon>
          </v-btn>
        </template>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn fab small color="primary" dark @click.stop="showIntroducerAdd = true" v-on="on">
              <v-icon small>fa-user-tie</v-icon>
            </v-btn>
          </template>
          <span>Add Introducer account</span>
        </v-tooltip>
      </v-speed-dial>
      <NewIntroducer :show.sync="showIntroducerAdd"></NewIntroducer>
    </v-content>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import AccountBusinesses from './AccountBusinesses';
import AccountUsers from './AccountUsers';
import MugenScroll from 'vue-mugen-scroll';
import NewIntroducer from './NewBusinessDialogs/NewIntroducer';

export default {
  components: {
    AccountBusinesses,
    AccountUsers,
    MugenScroll,
    NewIntroducer
  },
  name: 'accounts',
  data: () => ({
    fab: null,
    showIntroducerAdd: false,
    search: null,
    tabs: null,
    toggles: [],
    account: [
      {
        address: {},
        businesses: [
          {
            id: null
          }
        ],
        users: [
          {
            id: null
          }
        ]
      }
    ]
  }),
  computed: {
    ...mapGetters([
      'AccountsList',
      'AccountsTotal',
      'AccountsCurrentPage',
      'AccountsLastPage',
      'SelectedAccount',
      'BusinessTypes',
      'AccountFilters',
      'AccountSearch',
      'UILeftDrawer'
    ]),
    selectedAccount: {
      get() {
        return this.account;
      },
      set(id) {
        this.account = this.selectAccount(id);
      }
    },
    loading() {
      return this.AccountsTotal === null;
    },
    pagesAvailable() {
      return this.AccountsCurrentPage < this.AccountsLastPage;
    },
    screenIsWideEnough: function() {
      return this.$vuetify.breakpoint.width > 1600;
    }
  },
  methods: {
    ...mapActions([
      'getAccountsList',
      'selectAccount',
      'setAccountSearch',
      'addAccountFilter',
      'removeAccountFilter',
      'removeAllAccountFilters',
      'updateAccount',
      'getBusinessTypes',
      'updateUILeftDrawerState'
    ]),
    isDefined(value) {
      return !_.isUndefined(value);
    },
    scrollPage() {
      if (this.AccountsCurrentPage < this.AccountsLastPage) {
        this.getAccountsList(true).catch(error => {
          console.log(error);
        });
      }
    },
    updateDetails: function() {
      this.updateAccount({
        id: this.selectedAccount.id,
        updates: {
          name: this.account.name,
          address_1: this.account.address.line_1,
          address_2: this.account.address.line_2,
          address_3: this.account.address.line_3,
          address_4: this.account.address.line_4,
          address_5: this.account.address.line_5,
          post_code: this.account.address.post_code,
          email: this.account.email,
          phone: this.account.phone
        }
      });
    },
    toggleBusinessTypeFilter(businessType) {
      if (this.AccountFilters.includes(businessType)) {
        this.removeAccountFilter(businessType);
      } else {
        this.addAccountFilter(businessType);
      }
      this.getAccountsList();
    },
    clearSearch: function() {
      this.search = '';
      this.toggles = [];
      this.removeAllAccountFilters();
      this.setAccountSearch('');
    }
  },
  mounted() {
    this.getAccountsList();
    this.getBusinessTypes();
    _.merge(this.account, this.SelectedAccount);
  },
  watch: {
    SelectedAccount: function(account) {
      _.merge(this.account, account);
    },
    search: _.debounce(function(newValue) {
      this.setAccountSearch(newValue).then(() => this.getAccountsList());
    }, 500)
  }
};
</script>

<style lang="scss" scoped>
.full-height {
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}

.calc-height {
  height: calc(100vh - 64px);
  max-height: calc(100vh - 64px);
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}

.calc-filtered-height {
  height: calc(100vh - 267px);
  max-height: calc(100vh - 267px);
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}

.responsive {
  width: 100%;
  max-width: 135px;
  height: auto;
}

::v-deep {
  .input-group--text-field input,
  .input-group__selections__comma {
    font-size: 13px;
  }
}

::v-deep textarea {
  font-size: 13px;
}

.theme--light .input-group.input-group--solo-inverted.input-group--focused {
  background-color: #fff;

  ::v-deep input,
  ::v-deep .input-group__prepend-icon {
    color: rgba(0, 0, 0, 0.78);
  }
}

.btn-toggle--selected {
  box-shadow: none;

  .btn--active {
    color: #e91e63;

    > .btn__content:before {
      opacity: 0;
    }
  }
}

.theme--light .subheader.text--accent-1 {
  color: #e91e63;
}

::v-deep .tabs__item--active {
  color: #2196f3;
}

.hidden {
  display: none;
}

.selected {
  background: #b08faf;
  color: white;

  .list__tile__title {
    font-weight: 600;
  }

  .list__tile__sub-title {
    color: rgba(255, 255, 255, 0.87);
  }
}
.theme--light {
  .subheader.text--accent-1 {
    color: #e91e63;
  }
  &.v-list {
    background: inherit;
  }
}
::v-deep .v-list__tile.v-list__tile--link.theme--light {
  border-radius: 0 !important;
}
.list-bar {
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
  max-width: 280px;
  min-width: 280px;
  overflow-y: auto;
  width: 280px;
}
</style>
